import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from 'hooks/useToken';
import ImagenTipoArchivo from 'akasia-components/cliente/orden/ImagenTipoArchivo';
import PropTypes from 'prop-types';
import { FiPaperclip, FiPlus, FiCheck, FiDownload, FiTrash2, FiUser, FiFile, FiCalendar, FiClock } from 'react-icons/fi';
import { useToast } from 'context/providers/ToastProvider';

const SeccionArchivosEmpleados = (
    {
        idEmpleado,
    }
) => {

    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [loadingDeleteFile, setLoadingDeleteFile] = useState(false);
    const [loadingUploadFile, setLoadingUploadFile] = useState(false);
    const [archivos, setArchivos] = useState([]);
    const [dataFile, setDataFile] = useState({});
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [procesando, setProcesando] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [archivoToDelete, setArchivoToDelete] = useState(null);
    const [confirmText, setConfirmText] = useState('');
    const fileInputRef = React.useRef(null);


    /**
    * Carga archivo(s)
    */
    const onSubmitCargarArchivo = async (e) => {
        e.preventDefault();
        setLoadingUploadFile(true);

        // Obtener todos los archivos seleccionados
        const archivosSeleccionados = fileInputRef.current?.files;

        if (!archivosSeleccionados || archivosSeleccionados.length === 0) {
            showErrorToast('Es obligatorio cargar al menos un archivo');
            setLoadingUploadFile(false);
            return false;
        }

        var data = new FormData();
        data.append('idEmpleado', idEmpleado);

        // Agregar todos los archivos como FormFiles
        for (let i = 0; i < archivosSeleccionados.length; i++) {
            data.append('FormFiles', archivosSeleccionados[i]);
        }

        const response = await fetch("/api/usuario/CargarArchivoEmpleado", {
            method: 'POST',
            body: data,
            headers:
            {
                'Authorization': 'Bearer ' + token
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const objResponse = await response.json();
            console.log(data);

            if (objResponse.iResponseType == 1) {

                showSuccessToast(`Se subieron ${archivosSeleccionados.length} archivo(s) correctamente!`);
                setDataFile({});
                setSelectedFiles([]);

                if (objResponse.detalles) {
                    try {
                        const resultado = JSON.parse(objResponse.detalles);
                        console.log(resultado, "resultado completo");

                        // Procesar archivos
                        if (resultado.archivos && Array.isArray(resultado.archivos)) {
                            const archivosParseados = resultado.archivos.map(archivoString => {
                                try {
                                    // Parsear el string JSON que contiene un array
                                    const archivoArray = JSON.parse(archivoString);
                                    // Extraer el primer (y único) objeto del array
                                    return archivoArray[0];
                                } catch {
                                    return null;
                                }
                            }).filter(archivo => archivo !== null); // Filtrar archivos nulos
                            console.log(archivosParseados, "resultado completo");

                            setArchivos(prevArchivos => [...archivosParseados, ...prevArchivos]);
                        }


                    } catch (error) {
                        console.log("Error parsing detalles:", error);
                    }
                }
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }


            } else {
                showErrorToast(objResponse.vMessage);
                setLoadingUploadFile(false);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            setLoadingUploadFile(false);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setLoadingUploadFile(false);
    };

    /**
    * Elimina archivos
    */
    const eliminaArchivo = async (idOrdenArchivo_, id_, vNombreArchivo_) => {
        console.log(idOrdenArchivo_)
        setLoadingDeleteFile(idOrdenArchivo_);

        var idCatTipoUsuario1 = 3

        const response = await fetch("/api/usuario/EliminarArchivoEmpleado/?idEmpleadoArchivo=" + idOrdenArchivo_ + "&idEmpleado=" + id_ + "&name=" + vNombreArchivo_ + "&idCatTipoUsuario=" + idCatTipoUsuario1,
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

                setLoadingDeleteFile(false);
            });

        if (response.ok) {
            const objResponse = await response.json();
            console.log(objResponse);

            if (objResponse.iResponseType == 1) {
                setArchivos(prevArchivos => prevArchivos.filter(archivo => archivo.idArchivo !== idOrdenArchivo_));





                showSuccessToast("Archivo eliminado!");

            } else {
                showErrorToast(objResponse.vMessage);
            }

            setLoadingDeleteFile(false);
        }
        else {
            showErrorToast('Hubo un problema con la peticion Fetch:');

            setLoadingDeleteFile(false);
        }


    }

    /**
    * Obtiene archivos de empleado
    */
    const ObtenerArchivosEmpleado = async () => {
        setProcesando(true);
        console.log("entrando")
        console.log(procesando)

        const response = await fetch("/api/usuario/ObtenerArchivosDeEmpleado/?idEmpleado=" + idEmpleado, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {

                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);

                setProcesando(false);
                return; // 🔴 Detiene la ejecución si hubo error

            });
        console.log("entrando")
        console.log(response)
        if (response.ok) {
            const data = await response.json();
            console.log("========== ARCHIVOS DE CLIENTE ==========");
            if (data.iResponseType == 1) {
                const objResponse = JSON.parse(data.detalles);
                console.log("objResponse: ", objResponse);
                setArchivos(objResponse.table2);
                setProcesando(false);
            } else {
                showErrorToast(data.vMessage);
            }

            console.log("else")
            console.log(procesando)
        }
        else {
            console.log("else")
            console.log(procesando)
            showErrorToast(response.status + ' ' + response.statusText);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setProcesando(false);
        }

    };

    /**
    * Obtiene archivos de empleado según el idEmpleado
    */
    useEffect(() => {
        if (idEmpleado && idEmpleado !== "null" && !isNaN(idEmpleado)) {
            ObtenerArchivosEmpleado();
        }
    }, [idEmpleado]);

    ///**
    // * Obtiene archivos de empleado
    // */
    //useEffect(() => {
    //    if (idEmpleado != null) {
    //        ObtenerArchivosEmpleado();
    //    }
    //}, [idEmpleado]);

    return (
        <div className="document-section py-3 rounded border shadow-sm p-3">
            {procesando ? (
                <div
                    className="w-100 d-flex justify-content-center align-items-center"
                    style={{ minHeight: 120 }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: 1200,
                            background: "transparent",
                            borderRadius: 8,
                            border: "1px solid #e3e3e3",
                            boxShadow: "0 2px 8px #0001",
                            padding: 0,
                        }}
                    >
                        {/* Header del skeleton */}
                        <div
                            style={{
                                display: "flex",
                                background: "transparent",
                                padding: "12px 32px",
                                borderBottom: "1px solid #e3e3e3",
                                fontWeight: 600,
                                fontSize: 15,
                            }}
                        >
                            <div style={{ flex: 2 }}>
                                <Skeleton width={300} height={20} />
                            </div>
                            <div style={{ flex: 1, textAlign: "center" }}>
                                <Skeleton width={120} height={20} />
                            </div>
                        </div>
                        {/* Rows del skeleton */}
                        {[1, 2, 3, 4].map((i) => (
                            <div
                                key={i}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 32px",
                                    borderBottom: i < 2 ? "1px solid #e3e3e3" : "none",
                                }}
                            >
                                <div style={{ flex: 2 }}>
                                    <Skeleton height={25} width="80%" />
                                </div>
                                <div style={{ flex: 1, textAlign: "center" }}>
                                    <Skeleton height={16} width={100} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <>
                    <div className="rounded p-3 border" style={{ backgroundColor: 'transparent' }}>
                        {/* Header de documentos */}
                        <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                            <div className="d-flex align-items-center">
                                <FiPaperclip className="text-muted me-2" />
                                <span className="fw-medium text-dark">Documentos</span>
                                {archivos.length > 0 && (
                                    <span className="badge bg-light text-muted ms-2 rounded-pill small">
                                        {archivos.length}
                                    </span>
                                )}
                            </div>

                            {/* Botones de acción */}
                            <div className="d-flex align-items-center">
                                <div className="position-relative me-2">
                                    <input
                                        type="file"
                                        id="fileInput"
                                        className="d-none"
                                        multiple
                                        disabled={loadingUploadFile}
                                        onChange={(e) => {
                                            const files = Array.from(e.target.files || []);
                                            setSelectedFiles(files);
                                            if (files.length > 0) {
                                                setDataFile({
                                                    ...dataFile,
                                                    vArchivo: files[0],
                                                    vNombreDocumento: files[0].name,
                                                    vTipoDocumento: files[0].type,
                                                    vTamano: files[0].size,
                                                });
                                            }
                                        }}
                                        ref={fileInputRef}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary d-flex align-items-center px-2 py-1"
                                        onClick={() => fileInputRef.current?.click()}
                                        disabled={loadingUploadFile}
                                    >
                                        <FiPlus className="me-1" size={12} />
                                        <span className="small">Subir</span>
                                    </button>
                                </div>

                                {(dataFile.vArchivo || selectedFiles.length > 0) && (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-success d-flex align-items-center px-2 py-1"
                                        onClick={onSubmitCargarArchivo}
                                        disabled={loadingUploadFile}
                                    >
                                        {loadingUploadFile ? (
                                            <>
                                                <div className="spinner-border me-1"
                                                    style={{ width: '12px', height: '12px' }} role="status"></div>
                                                <span className="small">...</span>
                                            </>
                                        ) : (
                                            <>
                                                <FiCheck className="me-1" size={12} />
                                                <span className="small">OK</span>
                                            </>
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Lista de archivos */}
                        {archivos.length > 0 ? (
                            <div className="overflow-auto" style={{ maxHeight: '200px' }}>
                                {archivos.map((a, i) => (
                                    <div key={i} className="d-flex align-items-start py-2 px-2 border-bottom border-light rounded">
                                        {/* Icono del archivo */}
                                        <div className="me-2 d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{ width: '24px', height: '24px' }}>
                                            <ImagenTipoArchivo vNombreArchivo={a.vNombreArchivo} />
                                        </div>

                                        {/* Información del archivo */}
                                        <div className="flex-grow-1 overflow-hidden me-2">
                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                <span className="text-truncate fw-medium text-dark small"
                                                    title={a.vNombreArchivo}
                                                    >
                                                    {a.vNombreArchivo}
                                                </span>
                                            </div>

                                            {/* Metadatos del archivo */}
                                            <div className="d-flex flex-wrap gap-2 small text-muted">
                                                {a.vCreatedUser && (
                                                    <div className="d-flex align-items-center">
                                                        <FiUser className="me-1" size={10} />
                                                        <span>{a.vCreatedUser}</span>
                                                    </div>
                                                )}
                                                {a.dCreatedDate && (
                                                    <div className="d-flex align-items-center">
                                                        <FiCalendar className="me-1" size={10} />
                                                        <span>
                                                            {new Date(a.dCreatedDate).toLocaleDateString('es-ES', {
                                                                day: 'numeric',
                                                                month: 'long',
                                                                year: 'numeric'
                                                            })}
                                                        </span>
                                                    </div>
                                                )}
                                                {a.dCreatedDate && (
                                                    <div className="d-flex align-items-center">
                                                        <FiClock className="me-1" size={10} />
                                                        <span>
                                                            {new Date(a.dCreatedDate).toLocaleTimeString('es-ES', {
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Botones de acción */}
                                        <div className="d-flex align-items-center flex-shrink-0" style={{ gap: '4px' }}>
                                            {/* Botón descargar */}
                                            <a
                                                href={"/api/usuario/DescargarArchivo/?idEmpleado=" + idEmpleado + "&name=" + a.vNombreArchivo}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-sm btn-outline-primary p-1 d-flex align-items-center justify-content-center rounded"
                                                style={{ width: '28px', height: '28px' }}
                                                title="Descargar archivo"
                                            >
                                                <FiDownload size={14} />
                                            </a>

                                            {/* Botón eliminar */}
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger p-1 d-flex align-items-center justify-content-center rounded"
                                                style={{ width: '28px', height: '28px' }}
                                                onClick={() => {
                                                    setArchivoToDelete(a);
                                                    setConfirmText('');
                                                    setShowDeleteModal(true);
                                                }}
                                                title="Eliminar archivo"
                                                disabled={loadingDeleteFile === a.idArchivo}
                                            >
                                                {loadingDeleteFile === a.idArchivo ? (
                                                    <div className="spinner-border text-danger"
                                                        style={{ width: '12px', height: '12px' }} role="status"></div>
                                                ) : (
                                                    <FiTrash2 size={14} />
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-4">
                                <div className="text-muted small">
                                    No hay documentos adjuntos
                                </div>
                            </div>
                        )}

                        {/* Información de archivos seleccionados */}
                        {(dataFile.vArchivo || selectedFiles.length > 0) && (
                            <div className="mt-2 p-2 bg-light rounded">
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                    <span className="text-muted small fw-medium">
                                        {selectedFiles.length} archivo(s) seleccionado(s):
                                    </span>
                                    <button
                                        type="button"
                                        className="btn-close btn-sm"
                                        onClick={() => {
                                            setDataFile({
                                                ...dataFile,
                                                vArchivo: null,
                                                vNombreDocumento: '',
                                                vTipoDocumento: '',
                                                vTamano: 0,
                                            });
                                            setSelectedFiles([]);
                                            if (fileInputRef.current) {
                                                fileInputRef.current.value = '';
                                            }
                                        }}
                                    ></button>
                                </div>
                                <div className="small text-muted">
                                    {selectedFiles.map((file, index) => (
                                        <div key={index} className="d-flex align-items-center">
                                            <FiFile className="me-1" size={10} />
                                            <span className="text-truncate" style={{ maxWidth: '200px' }}>
                                                {file.name}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}



            {/* Modal de confirmación para eliminar */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>¿Estás seguro de que deseas eliminar el archivo: <strong style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{archivoToDelete?.vNombreArchivo}</strong>?</p>
                    <p>Para confirmar, escribe <strong>ELIMINAR</strong> en el campo de texto:</p>
                    <Form.Control
                        type="text"
                        value={confirmText}
                        onChange={(e) => setConfirmText(e.target.value)}
                        placeholder="Escribe 'ELIMINAR' para confirmar"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="danger"
                        disabled={confirmText.toUpperCase() !== 'ELIMINAR'}
                        onClick={() => {
                            if (confirmText.toUpperCase() === 'ELIMINAR' && archivoToDelete) {
                                eliminaArchivo(
                                    archivoToDelete.idArchivo,
                                    archivoToDelete.idEmpleado,
                                    archivoToDelete.vNombreArchivo
                                );
                                setShowDeleteModal(false);
                                setConfirmText('');
                                setArchivoToDelete(null);
                            }
                        }}
                    >
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}



SeccionArchivosEmpleados.propTypes = {
    idEmpleado: PropTypes.number,
};

export default SeccionArchivosEmpleados;
